export default (theme) => ({
    padding: { padding: theme.spacing(1) },
    box: {
        display: "flex",
        justifyContent: "center",
        position: "absolute",
        top: "50%",
        width: "100%",
    },
    yesNoActions: {
        padding: `${theme.spacing(1)} 0 ${theme.spacing(1)}`,
    },
});
